import type { ThemeMode } from '@theme/createAppTheme';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  mode: ThemeMode;
  toggleMode: () => void;
}

const getPreferredMode = (): ThemeMode =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: getPreferredMode(),
      toggleMode: () => {
        set({ mode: get().mode === 'light' ? 'dark' : 'light' });
      },
    }),
    { name: 'ops-utility-hub-theme-mode' },
  ),
);
